import { createFileRoute, Outlet } from "@tanstack/react-router";
import type { ReactNode } from "react";
import PublicScaffold from "@/routes/-components/PublicScaffold.js";

const Root = (): ReactNode => {
    return (
        <PublicScaffold>
            <Outlet />
        </PublicScaffold>
    );
};

export const Route = createFileRoute("/review")({
    component: Root,
});
